import React, {useState, useEffect} from 'react';
import { useParams } from 'react-router-dom';
import {client} from "../../client";
import Spinner from '../spinner/Spinner';
import MasonryLayout from "../masonry-layout/MasonryLayout";
import { feedQuery, searchQuery } from '../../utils/data';

const Feed = () => {
    const [pins, setPins] = useState();
    const [isLoading, setLoading] = useState(false);
    const { categoryId } = useParams();
    const ideaName = categoryId || 'new';
    const message = `We are adding ${ideaName} ideas to your feed!`;

    useEffect(() => {
        if (categoryId) {
            setLoading(true);
            const query = searchQuery(categoryId);
            client.fetch(query)
                .then((data) => {
                    setPins(data);
                    setLoading(false);
                })
                .catch(err => {
                    console.error(err);
                    setLoading(false);
                });
        } else {
            setLoading(true);

            client.fetch(feedQuery).then((data) => {
                setPins(data);
                setLoading(false);
            }).catch(err => {
                console.error(err);
                setLoading(false);
            });
        }
    }, [categoryId])

    if (isLoading) {
        return <Spinner message={message} />
    }

    return (
        <div>
            {pins && (
                <MasonryLayout pins={pins} />
            )}
        </div>
    );
};

export default Feed;
